import {
  differenceInSeconds,
  differenceInMinutes,
  differenceInHours,
  differenceInDays,
  differenceInWeeks,
  differenceInMonths,
} from 'date-fns';
import i18n from 'i18next';

const { t } = i18n;

export const timeAgo = (date: string | Date) => {
  const now = new Date();
  const past = new Date(date);

  const seconds = differenceInSeconds(now, past);
  if (seconds < 10) return t('notification:justNow');
  if (seconds < 60) return t('notification:secondsAgo', { seconds });

  const minutes = differenceInMinutes(now, past);
  if (minutes < 60) return t('notification:minutesAgo', { minutes });

  const hours = differenceInHours(now, past);
  if (hours < 24) return t('notification:hoursAgo', { hours });

  const days = differenceInDays(now, past);
  if (days === 1) {
    return t('notification:dayAgo');
  }

  if (days < 7) {
    return t('notification:daysAgo', { days });
  }

  const weeks = differenceInWeeks(now, past);
  if (weeks === 1) {
    return t('notification:weekAgo');
  }
  if (weeks < 5) {
    return t('notification:weeksAgo', { weeks });
  }

  const months = differenceInMonths(now, past);
  if (months === 1) {
    return t('notification:monthAgo');
  }
  return t('notification:monthsAgo', { months });
};
